import React from "react";
import "./User-Management.css";
import Header from "../../Component/header/Header";
import Sidebar from "../../Component/sidebar/sidebar";
import UserMgmt from "../../Component/sub-userMgmt/SubUserMgmt";

function UserManagement() {
  return (
    <div className="container">
      <div className="row row-cols-2">
        {/* SIDEBAR DESIGN */}
        <div className="col-2 sidebar">
          <Sidebar />
        </div>

        {/* CONTENT DESIGN */}
        <div className="col-10 content">
          <Header title={"User Mgmt"} />
          {/* management section */}
          < UserMgmt />
        </div>
      </div>
    </div>
  );
}

export default UserManagement;
